export enum StorageKeys {
  IS_AUTO_LOGOUT_ENABLED = 'isAutoLogoutEnabled',
}
